import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Megaphone, Save, Loader2 } from "lucide-react";

export default function ReleaseNotesEditor() {
  const [version, setVersion] = useState("");
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/app-release")
      .then(({ data }) => { setVersion(data.version || ""); setText((data.notes || []).join("\n")); })
      .catch((e) => console.error("Admin: load release notes failed", e))
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/admin/app-release", { version, notes: text });
      setText((data.notes || []).join("\n"));
      toast.success("Saved — shows in the next 'Update required' popup.");
    } catch (e) {
      toast.error("Could not save — please retry.");
    } finally {
      setBusy(false);
    }
  };

  const inp = "w-full bg-black border border-white/15 text-white text-sm px-3 py-2 rounded-none";

  return (
    <div className="mb-10 border border-[#E2E30A]/30 p-5" data-testid="admin-release-notes">
      <div className="flex items-center gap-2 mb-1">
        <Megaphone className="h-4 w-4 text-[#E2E30A]" />
        <h3 className="font-display uppercase tracking-tight text-white">Update popup — “What's new”</h3>
      </div>
      <p className="text-[11px] text-zinc-400 mb-3">Shown in the forced “Update required” popup users see after you redeploy. One bullet per line (up to 30).</p>
      {loading ? (
        <p className="text-sm text-zinc-400">Loading…</p>
      ) : (
        <div className="space-y-3">
          <div>
            <label className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-400 mb-1 block">Version label (optional)</label>
            <input data-testid="release-version" className={inp} value={version} onChange={(e) => setVersion(e.target.value)} placeholder="e.g. v1.4 — August" />
          </div>
          <div>
            <label className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-400 mb-1 block">What's new (one per line)</label>
            <textarea data-testid="release-notes" rows={14} className={inp} value={text} onChange={(e) => setText(e.target.value)} placeholder={"New Recipe Ideas hub with photos & upvotes\nFaster, more reliable updates\nBug fixes"} />
          </div>
          <button data-testid="release-save" onClick={save} disabled={busy}
            className="inline-flex items-center gap-2 px-4 py-2 text-[11px] uppercase tracking-wider bg-[#E2E30A] text-black font-bold hover:bg-[#c9ca09] disabled:opacity-50">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Save
          </button>
        </div>
      )}
    </div>
  );
}
